import React from 'react';
import FieldModal from '../../../components/modals/fieldModal';

class DeleteSubmissionModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isDeleting: false };
    }

    deleteSubmission = () => {
        this.setState({ isDeleting: true });
        this.props.deleteSubmission(() => {
            this.setState({ isDeleting: false });
            this.props.toggle();
        });
    };

    render() {
        const { isOpen, toggle, selectedSubmissionCount } = this.props;
        const { isDeleting } = this.state;
        const isMultiple = selectedSubmissionCount > 1;
        return (
            <FieldModal
                size="small"
                isOpen={isOpen}
                modalTitle={'Delete Selected Submission' + (isMultiple ? 's' : '')}
                bodyHeaderText=""
                bodyContent={() =>
                    'Are you sure you want to delete the selected submission' + (isMultiple ? 's' : '') + '?'
                }
                toggle={toggle}
                actionButtonLabel={isDeleting ? 'Deleting...' : 'Delete'}
                actionButton={this.deleteSubmission}
                actionButtonDisabled={isDeleting}
                isDelete={true}
            />
        );
    }
}

export default DeleteSubmissionModal;
